"use client";

import React, { useEffect } from "react";

export const consoleWelcomeMessage = `#
#   ________  
#  |_   __  | 
#    | |_ \\_| 
#    |  _|    
#   _| |_     
#  |_____|    
#             
# Welcome to Faire!
# Wanna know more about our tech?    https://faire.tech
# Wanna join our team?               https://faire.com/careers
# Found a bug?                       https://faire.com/support
#`;

export const displayConsoleWelcomeMessage = () => {
  // We want to display a welcome message for developers in the console.
  // This is the only thing we should use console.log for in the application.
  // eslint-disable-next-line no-console
  console.log(consoleWelcomeMessage);
};

export const ConsoleWelcomeMessageComponent: React.FC = () => {
  useEffect(() => {
    displayConsoleWelcomeMessage();
  }, []);
  return null;
};
